if (!customElements.get('jotform-trigger')) {
  class JotformTrigger extends HTMLElement {
    constructor() {
      super();

      this.buttons = this.querySelectorAll('[data-jotform-button]');

      this.buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();

          const jotform = new JotformFeedback({
            formId: `${button.dataset.jotformButton}`,
            base: 'https://form.jotform.com/',
            windowTitle: 'Custom and/or Corporate Gifting Inquiry',
            backgroundColor: '#FFA500',
            fontColor: '#FFFFFF',
            type: 'false',
            height: 500,
            width: 700,
            openOnLoad: true,
          });

          window.jotformEmbedHandler(
            `iframe[id='${button.dataset.jotformButton}']`,
            'https://form.jotform.com/',
          );
        });
      });
    }
  }

  customElements.define('jotform-trigger', JotformTrigger);
}
